<template>
  <div>
    <select-base
      ref="tipoAtividadeSelect"
      v-model="valueInner"
      :disabled="disabled"
      :require="require_"
      :multiple="multiple"
      :label="'Tipos de atividade'"
      :label-select="'nome'"
      :carregar="carregarTiposAtividade"
      :filtro-adicional="filtroAdicional"
      @input="enviarParaPai"
      @keydown.enter.native="eventoTecla"
    />
  </div>
</template>

<script>
import api from '@/app-modulo/comercial/tipo-atividade/shared/services/api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'TipoAtividadeSelect',
  components: {
    SelectBase: () => import('@/shared/components/select-base/SelectBase.vue'),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    require: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Object, Array],
      default: () => { },
    },
    filtroAdicional: {
      type: Function,
      default: () => null,
    },
  },
  data() {
    return {
      value_: {},
      filtros: [
        {
          coluna: 'Nome',
          valor: '',
        },
      ],
    }
  },
  computed: {
    valueInner: {
      set(value) {
        // eslint-disable-next-line no-underscore-dangle
        this.value_ = value
      },
      get() {
        // eslint-disable-next-line no-underscore-dangle
        return this.value_
      },
    },
    require_: {
      get() {
        return this.require
      },
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
      }
    },
  },
  created() {
    this.valueInner = this.value
  },
  methods: {
    carregarTiposAtividade(filtros) {
      return api.getAtividadesResumidas(filtros)
    },
    enviarParaPai() {
      this.$emit('input', this.valueInner)
    },
    eventoTecla() {
      this.$emit('tecla-enter')
    },
    focus() {
      this.$refs.tipoAtividadeSelect.$refs.selectBaseSelect.$refs.search.focus()
    },
  },
}
</script>
